import { motion } from "framer-motion";
import { MapPin, ChevronDown } from "lucide-react";
import { HOTEL, IMAGES } from "../../data/content";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Tropical rainforest meeting the Pacific shore at Playa Mecana"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-forest-900/85 via-forest-900/30 to-forest-900/40" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-8 pb-20 sm:pb-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="flex items-center gap-2 text-sand-200/90 mb-6"
        >
          <MapPin size={16} className="text-earth-400" />
          <span className="text-xs sm:text-sm tracking-[0.2em] uppercase font-semibold">
            {HOTEL.location}
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.15, ease: "easeOut" }}
          className="font-serif font-light text-sand-100 text-4xl sm:text-6xl lg:text-7xl leading-[1.05] max-w-4xl text-balance"
        >
          Set within tropical rainforests, edged by virgin shores.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.35, ease: "easeOut" }}
          className="mt-6 max-w-xl text-sand-200/90 text-base sm:text-lg leading-relaxed"
        >
          A private nature reserve on Colombia's wild Pacific coast — where the
          jungle, the mangroves and the ocean become your everyday.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5, ease: "easeOut" }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <a
            href="#contact"
            data-testid="hero-reserve-button"
            className="inline-flex items-center justify-center rounded-full bg-earth-500 hover:bg-earth-600 text-white px-8 py-4 text-sm font-semibold tracking-wide transition-colors duration-300"
          >
            Request a Stay
          </a>
          <a
            href="#experiences"
            data-testid="hero-explore-button"
            className="inline-flex items-center justify-center rounded-full border border-sand-100/40 text-sand-100 hover:bg-sand-100/10 px-8 py-4 text-sm font-semibold tracking-wide transition-colors duration-300"
          >
            Explore Experiences
          </a>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 8, 0] }}
        transition={{ delay: 1, duration: 2, repeat: Infinity }}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-sand-100/70"
      >
        <ChevronDown size={26} />
      </motion.div>
    </section>
  );
};
